import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getAuthToken } from '../utils/auth';
import './Login.css';
import BASE_URL from '../utils/api';

function DadosUsuarios() {
    const location = useLocation();
    const navigate = useNavigate();
    const prefill = (location.state && location.state.prefill) || {};
    const fileInputRef = useRef(null);

    const [formData, setFormData] = useState({
        nomeUsuario: prefill.nome || '',
        email: prefill.email || '',
        telefone: '',
        tipoUsuario: '', // 'PF' ou 'PJ'
        cpf: '',
        cnpj: ''
    });
    const [fotoPerfil, setFotoPerfil] = useState(null);
    const [fotoPreview, setFotoPreview] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const BASE_URLS = [BASE_URL];

    const apiCall = async (endpoint, method = 'POST', data = null) => {
        let lastError;
        for (const baseUrl of BASE_URLS) {
            try {
                const url = `${baseUrl}/${endpoint}`;
                const config = { method, headers: { 'Content-Type': 'application/json' } };
                const token = getAuthToken();
                if (token) config.headers['Authorization'] = 'Bearer ' + token;
                if (data) config.body = JSON.stringify(data);
                const response = await fetch(url, config);
                if (!response.ok) throw new Error(`Erro ${response.status}`);
                return await response.json();
            } catch (err) {
                lastError = err;
                continue;
            }
        }
        throw lastError;
    };

    useEffect(() => {
        // focus first input
        const el = document.getElementById('nomeUsuario');
        if (el) el.focus();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setError('');
    };

    const handleFotoClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFotoChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        
        if (!file.type.startsWith('image/')) {
            setError('Por favor, selecione uma imagem válida.');
            return;
        }
        
        if (file.size > 5 * 1024 * 1024) {
            setError('A imagem deve ter no máximo 5MB.');
            return;
        }
        
        const reader = new FileReader();
        reader.onload = () => {
            setFotoPreview(reader.result);
            // Extrair apenas a parte base64
            const base64Data = reader.result.split(',')[1] || reader.result;
            setFotoPerfil(base64Data);
        };
        reader.readAsDataURL(file);
    };

    // Obter inicial do nome
    const getInitial = (name) => {
        if (!name) return '+';
        const clean = name.replace(/[^a-zA-ZÀ-ÿ]/g, '');
        return clean.charAt(0).toUpperCase() || '+';
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.nomeUsuario || !formData.email || !formData.telefone) {
            setError('Nome, email e telefone são obrigatórios.');
            return;
        }

        setLoading(true);
        try {
            const payload = {
                NomeUsuario: formData.nomeUsuario,
                Email: formData.email,
                Telefone: formData.telefone
            };
            if (fotoPerfil) {
                payload.FotoPerfil = fotoPerfil;
            }
            await apiCall('DadosUsuario', 'POST', payload);
            alert('Dados do usuário salvos com sucesso!');
            navigate('/sidebar/Login');
        } catch (err) {
            console.error('Erro ao salvar dados do usuário:', err);
            setError('Erro ao salvar. Tente novamente.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <h2>📇 Dados do Usuário</h2>
                    <p>Preencha os campos obrigatórios para completar o cadastro</p>
                </div>

                <form onSubmit={handleSubmit} className="login-form">
                    {error && <div className="error-message">⚠️ {error}</div>}

                    {/* Foto de Perfil */}
                    <div className="form-group" style={{ alignItems: 'center' }}>
                        <label>Foto de Perfil</label>
                        <input
                            type="file"
                            ref={fileInputRef}
                            onChange={handleFotoChange}
                            accept="image/*"
                            style={{ display: 'none' }}
                        />
                        <div 
                            className="dados-usuario-foto-circle"
                            onClick={handleFotoClick}
                            style={{
                                width: 100,
                                height: 100,
                                borderRadius: '50%',
                                background: 'rgb(235, 133, 0)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                border: '3px solid rgb(235, 133, 0)',
                                overflow: 'hidden',
                                marginTop: 8
                            }}
                        >
                            {fotoPreview ? (
                                <img 
                                    src={fotoPreview} 
                                    alt="Foto de perfil" 
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                            ) : (
                                <span style={{ 
                                    fontSize: formData.nomeUsuario ? 42 : 36, 
                                    fontWeight: 700, 
                                    color: '#fff' 
                                }}>
                                    {formData.nomeUsuario ? getInitial(formData.nomeUsuario) : '+'}
                                </span>
                            )}
                        </div>
                        <span style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                            Clique para adicionar foto
                        </span>
                    </div>

                    <div className="form-group">
                        <label htmlFor="nomeUsuario">Nome de Usuário</label>
                        <input id="nomeUsuario" name="nomeUsuario" value={formData.nomeUsuario} onChange={handleChange} required disabled={loading} />
                    </div>

                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input id="email" name="email" type="email" value={formData.email} onChange={handleChange} required disabled={loading} />
                    </div>

                    <div className="form-group">
                        <label htmlFor="telefone">Telefone</label>
                        <input id="telefone" name="telefone" value={formData.telefone} onChange={handleChange} required disabled={loading} />
                    </div>

                    <div className="login-actions">
                        <button type="submit" className="login-btn" disabled={loading}>{loading ? '⏳ Salvando...' : 'Salvar e Concluir'}</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default DadosUsuarios;
